export default {
  title: 'Aan de slag',
  description: 'Om de huidige pagina te laden, moet u de Aan de slag-gids voltooien',
  button: 'Aan de slag',
};
